export default "__VITE_ASSET__CNYCcpvb__"